import { fetch } from '@/shared/fetch';

export const deleteFile = async (guid: string) => {
    return await fetch<string>(
        `/api/files/doctor-delete-file/${guid}`,
        'DELETE',
    );
};
